/** Phases in running order. Index is used for "has this happened yet". */
export const SHOW_PHASE_ORDER = [
    "preshow",
    "gates_open",
    "opening_ceremony",
    "moment_of_silence",
    "live",
    "closing_mayabini",
    "ended",
];
/** True while the tribute video should be playing. */
export function isVideoPhase(phase) {
    return phase === "live" || phase === "closing_mayabini";
}
/** Client -> server message names. */
export const ClientMessage = {
    Input: "input",
    Emote: "emote",
    LightDiya: "light_diya",
    OfferFlower: "offer_flower",
    SubmitTribute: "submit_tribute",
    RequestSync: "request_sync",
    Sit: "sit",
    Stand: "stand",
    Pray: "pray",
    Sing: "sing",
    SetStation: "set_station",
    /** Ask a nearby player to talk. Nothing is connected until they accept. */
    VoiceRequest: "voice_request",
    VoiceResponse: "voice_response",
    VoiceSignal: "voice_signal",
    VoiceEnd: "voice_end",
    VoiceReport: "voice_report",
};
/** Server -> client message names. */
export const ServerMessage = {
    Sync: "sync",
    Rejected: "rejected",
    TributeAccepted: "tribute_accepted",
    GlobalStats: "global_stats",
    VoiceInvite: "voice_invite",
    VoiceAnswer: "voice_answer",
    VoiceSignal: "voice_signal",
    VoiceClosed: "voice_closed",
};
//# sourceMappingURL=types.js.map